export default function fontFaceName(name) {
  return `MG monogram ${name}`;
}
